// @core/api/endpoints/affiliate/list_affiliates.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAffiliatesResponse,
} from '../../../types/affiliate';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/affiliate';

/**
 * List affiliates
 * Returns a paginated list of affiliates. Supports filtering and sorting.
 */
export async function ListAffiliates(
  params?: PaginatedRequest & {
    q?: string | number | boolean;
    status?: string | number | boolean;
    tier_id?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListAffiliatesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/affiliates`;
  const requestOptions = options;
  return client.get<ListAffiliatesResponse>(requestPath, { ...requestOptions, params });
}
